import React from "react";
import { RiVipLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import axios from "axios";

const VipRequired = () => {
  const { user } = useContext(UserContext);
  const [userSubscription, setUserSubscription] = useState({
    Premium: false,
  });

  useEffect(() => {
    if (user) {
      axios
        .get(`/auth/profile/${user?.id}`)
        .then(({ data }) => {
          if (data) {
            setUserSubscription(data.subscription);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user, setUserSubscription]);

  const isSubscribed =
    userSubscription && new Date(userSubscription.expiresAt) > new Date();

  return (
    <div className="vip_required_container">
      <NavLink to={!user ? "/login" : isSubscribed ? "/predictions/premium" : "/plan"} className="vip_required">
        <RiVipLine size={30} color="#FFD700" />
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          VIP Status:{" "}
        </span>
        <span
          style={{
            color: "#d7d7d7ff",
          }}
        >
          {!user ? "Login Required" : isSubscribed ? "Active" : "Inactive"}
        </span>
      </NavLink>
    </div>
  );
};

export default VipRequired;
